import React from "react";

class ErrorPage extends React.Component {
    render() {
        return (
            <div style={{ textAlign: "center" }}>
                <h1 style={{
                    fontFamily: "cursive",
                    fontStyle: "italic",
                    fontSize: "100px"
                }}>
                    Oops!
                </h1>
                <h1>
                    <br />{window.GlobalErrorMessage ?? "Looks like our UI needs some patching up."}
                </h1>
                <h2>
                    <br />Please contact us at 1-833-932-1877 if the error persists.
                    <br />Thank you for your patience.
                </h2>
            </div>
        );
    }
}

export default ErrorPage;